/* Tab, Oct 12 2026 — Quick View (sections/tab-quick-view.liquid): opens the restyled quick view from any [data-tab-qv="<handle>"] link
   (Complete the set / You may also like "Choose options") and from the theme's own <quick-view> elements (cart drawer), and runs the
   gallery + availability logic inside it. Variant selection / Add to cart / cart drawer refresh are the theme's (product.js). Loaded globally.
   Oct 12 audit fix #1: TabQV.prefetch(handle) warms the quick-view HTML (the looks popup calls it when a dot opens / is hovered) and TabQV.open
   reuses it; if the quick view has not filled 3 s after the click, the shopper is sent to the product page instead of a spinner. */
(function () {
  'use strict';
  if (window.TabQV) { window.TabQV.initAll(); return; }
  var TabQV = window.TabQV = {};
  var lastTrigger = null, openId = 0;
  var drawer = function () { return document.getElementById('Product-Drawer'); };

  function initSection(root) {
    if (!root || root.dataset.tqvReady) return;
    root.dataset.tqvReady = '1';
    var sectionId = root.dataset.section;
    var track = root.querySelector('.tqv-gtrack');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.tqv-gslide'));
    var thumbWrap = root.querySelector('.tqv-gthumbs');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.tqv-gth'));
    var countEl = root.querySelector('.tqv-gcount');
    var prevBtn = root.querySelector('.tqv-gprev');
    var nextBtn = root.querySelector('.tqv-gnext');
    var gmain = root.querySelector('.tqv-gmain');
    var shown = [], shownThumbs = [], current = 0;
    var variantData = null;
    try { var vs = root.querySelector('variant-selects script[type="application/json"]'); if (vs) variantData = JSON.parse(vs.textContent); } catch (e) {}

    function orderFor(list, key) {
      var own = [], common = [], rest = [];
      list.forEach(function (el) {
        if (key && el.dataset.group === key) own.push(el);
        else if (el.dataset.group === 'common') common.push(el);
        else rest.push(el);
      });
      if (!own.length && !common.length) return list.slice();
      if (!own.length && key) return list.slice();
      return own.concat(common);
    }
    function setGroup(mediaId, keepIndex) {
      if (!track) return;
      var key = mediaId != null ? String(mediaId) : null;
      shown = orderFor(slides, key);
      var seen = {};
      shown = shown.filter(function (s) {
        var img = s.querySelector('img'); if (!img) return true;
        var file = (img.getAttribute('src') || '').split('/').pop().split('?')[0];
        var stem = /^([0-9]+)(?:_[a-z0-9-]+)?\.(jpg|jpeg|png|webp)$/i.exec(file);
        var id = stem ? stem[1] : file;
        if (seen[id]) return false; seen[id] = 1; return true;
      });
      var ids = {}; shown.forEach(function (s) { ids[s.dataset.media] = 1; });
      shownThumbs = orderFor(thumbs, key).filter(function (t) { return ids[t.dataset.media]; });
      slides.forEach(function (s) { s.classList.remove('is-shown'); });
      thumbs.forEach(function (t) { t.classList.remove('is-shown'); });
      shown.forEach(function (s) { s.classList.add('is-shown'); track.appendChild(s); });
      if (thumbWrap) { shownThumbs.forEach(function (t) { t.classList.add('is-shown'); thumbWrap.appendChild(t); }); thumbWrap.classList.toggle('is-single', shownThumbs.length < 2); }
      if (gmain) gmain.classList.toggle('is-single', shown.length < 2);
      current = keepIndex ? Math.min(current, shown.length - 1) : 0;
      track.scrollTo({ left: current * track.clientWidth, behavior: 'auto' });
      paint();
    }
    function paint() {
      if (countEl) countEl.textContent = (current + 1) + ' / ' + shown.length;
      shownThumbs.forEach(function (t, i) { t.classList.toggle('on', i === current); });
      if (prevBtn) prevBtn.disabled = current <= 0;
      if (nextBtn) nextBtn.disabled = current >= shown.length - 1;
      var on = shownThumbs[current]; if (on && thumbWrap) { var r = on.getBoundingClientRect(), w = thumbWrap.getBoundingClientRect(); if (r.left < w.left || r.right > w.right) on.scrollIntoView({ block: 'nearest', inline: 'center' }); }
    }
    function goTo(i) { if (!shown.length) return; current = Math.max(0, Math.min(i, shown.length - 1)); track.scrollTo({ left: current * track.clientWidth, behavior: 'smooth' }); paint(); }
    if (track) {
      var scrollT;
      track.addEventListener('scroll', function () { clearTimeout(scrollT); scrollT = setTimeout(function () { var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); if (i !== current) { current = i; paint(); } }, 60); });
      track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') goTo(current + 1); if (e.key === 'ArrowLeft') goTo(current - 1); });
      window.addEventListener('resize', function () { if (root.isConnected) track.scrollTo({ left: current * track.clientWidth }); });
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(shownThumbs.indexOf(t)); }); });

    // Availability painted by VALUE (same rule as the product page): a size is crossed out when that (set, size) is missing or sold out.
    var vsel = root.querySelector('variant-selects');
    function fieldsets() { return vsel ? Array.prototype.slice.call(vsel.querySelectorAll('fieldset')) : []; }
    function selectedValues() { return fieldsets().map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; }); }
    function matchVariant(opts) {
      if (!variantData) return null;
      for (var i = 0; i < variantData.length; i++) { var v = variantData[i], ok = true; for (var j = 0; j < opts.length; j++) { if (opts[j] != null && v.options[j] !== opts[j]) { ok = false; break; } } if (ok) return v; }
      return null;
    }
    function paintAvailability() {
      if (!vsel || !variantData) return;
      var sel = selectedValues();
      fieldsets().forEach(function (fs, i) {
        fs.querySelectorAll('input').forEach(function (inp) {
          var exists = false, avail = false, k, v;
          if (i === 0) { for (k = 0; k < variantData.length; k++) { v = variantData[k]; if (v.options[0] === inp.value) { exists = true; if (v.available) { avail = true; break; } } } }
          else { var opts = sel.slice(); opts[i] = inp.value; v = matchVariant(opts); exists = !!v; avail = !!(v && v.available); }
          inp.classList.toggle('is-disabled', !avail);
          inp.classList.toggle('is-missing', !exists);
          inp.setAttribute('aria-disabled', avail ? 'false' : 'true');
        });
      });
    }
    // Picking a set whose current size is missing/sold out moves to the first available size of that set (capture phase, before the theme reads the radios)
    root.querySelectorAll('.tpc-opt--photos').forEach(function (fs) {
      fs.addEventListener('change', function () {
        if (!variantData) return;
        var all = fieldsets(), sel = selectedValues(), v = matchVariant(sel);
        if (v && v.available) return;
        var others = all.filter(function (f) { return f !== fs; }); if (!others.length) return;
        var of = others[0], oi = all.indexOf(of), inputs = of.querySelectorAll('input');
        for (var n = 0; n < inputs.length; n++) { var o = sel.slice(); o[oi] = inputs[n].value; var vv = matchVariant(o); if (vv && vv.available) { inputs[n].checked = true; return; } }
        if (!v) { for (n = 0; n < inputs.length; n++) { o = sel.slice(); o[oi] = inputs[n].value; if (matchVariant(o)) { inputs[n].checked = true; return; } } }
      }, true);
    });
    function syncButton(v) {
      var b = root.querySelector('.tpc-atc'), t = b && b.querySelector('.single-add-to-cart-button--text'); if (!b || !t) return;
      var strings = (window.theme && theme.variantStrings) || {};
      if (v && v.available) { b.removeAttribute('disabled'); b.classList.remove('sold-out'); t.textContent = strings.addToCart || 'Add to cart'; }
      else { b.setAttribute('disabled', 'disabled'); b.classList.add('sold-out'); t.textContent = strings.soldOut || 'Sold out'; }
    }
    // Scope the theme's button painting to THIS product, not the host product page.
    if (vsel) {
      vsel.toggleAddButton = function (disabled, text) {
        var b = root.querySelector('.tpc-atc'); if (!b) return;
        b.disabled = !!disabled;
        if (!disabled) b.classList.remove('sold-out', 'loading');
        var t = b.querySelector('.single-add-to-cart-button--text');
        if (t) { if (!disabled) t.textContent = (window.theme && theme.variantStrings.addToCart) || 'Add to cart'; else if (text) t.textContent = text; }
      };
      vsel.setUnavailable = function () { syncButton(null); };
    }
    document.addEventListener('product:variant-change', function (e) {
      if (!e.detail || e.detail.sectionId !== sectionId || !root.isConnected) return;
      paintAvailability();
      var v = e.detail.variant;
      if (v && v.featured_media) setGroup(v.featured_media.id);
      syncButton(v);
      setTimeout(function () { syncButton(v); }, 50);
    });
    paintAvailability();
    setTimeout(paintAvailability, 300);
    setGroup(root.dataset.initialMedia || null);
    var d = drawer(); if (d) d.classList.add('tqv-drawer');
  }

  function initAll() { document.querySelectorAll('.tqv[data-section]').forEach(initSection); }
  TabQV.initAll = initAll;

  function loadScript(src) {
    if (!src) return;
    var abs = src; try { abs = new URL(src, location.href).href; } catch (e) {}
    var have = Array.prototype.some.call(document.scripts, function (s) { return s.src === abs; });
    if (have) return;
    var s = document.createElement('script'); s.src = src; document.head.appendChild(s);
  }

  var FALLBACK_MS = 3000;   // Oct 12 audit fix #1: after this long on the spinner, go to the product page instead
  var prefetched = {};      // quick-view href -> Promise<string> (the HTML), kept for the life of the page
  function rootUrl() { return (window.theme && theme.routes && theme.routes.root_url) || '/'; }
  function hrefFor(handle, variantId) {
    var href = (rootUrl() + '/products/' + handle + '?view=quick-view').replace('//', '/');
    if (variantId) href += '&variant=' + encodeURIComponent(variantId);
    return href;
  }
  // Oct 12 audit fix #3: the quick view's own stylesheets (tab-pdp-c.css …) are fetched into the HTTP cache with the HTML, so the injected
  // <link> tags resolve at once; and the content stays invisible until those <link>s have loaded (max 1.5 s), so it never paints unstyled.
  var warmed = {};
  function warmStyles(html) {
    var re = /<link\b[^>]*>/gi, m;
    while ((m = re.exec(html))) {
      var tag = m[0]; if (!/rel=["']stylesheet["']/i.test(tag)) continue;
      var h = /href=["']([^"']+)["']/i.exec(tag); if (!h) continue;
      var u = h[1]; if (warmed[u]) continue; warmed[u] = 1;
      try { fetch(u, { mode: 'no-cors', credentials: 'omit' }).catch(function () {}); } catch (e) {}
    }
  }
  function waitForStyles(content, maxMs) {
    var pending = Array.prototype.filter.call(content.querySelectorAll('link[rel="stylesheet"]'), function (l) { return !l.sheet; });
    if (!pending.length) return;
    var n = pending.length, t;
    content.classList.add('tqv-waiting');
    function done() { if (--n > 0) return; clearTimeout(t); content.classList.remove('tqv-waiting'); }
    pending.forEach(function (l) { l.addEventListener('load', done, { once: true }); l.addEventListener('error', done, { once: true }); });
    t = setTimeout(function () { n = 0; content.classList.remove('tqv-waiting'); }, maxMs || 1500);
  }
  function fetchQV(href) {
    if (prefetched[href]) return prefetched[href];
    var p = fetch(href, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('quick view ' + r.status); return r.text(); });
    p.then(function (text) { warmStyles(text); }).catch(function () {});
    p.catch(function () { delete prefetched[href]; });
    prefetched[href] = p;
    return p;
  }
  // Warm the quick-view HTML before the shopper clicks (looks popup, hover on a dot, …). Safe to call repeatedly.
  TabQV.prefetch = function (handle, variantId) { if (!handle) return null; try { return fetchQV(hrefFor(handle, variantId)); } catch (e) { return null; } };

  // Open the quick view for a product handle (same steps as the theme's <quick-view> element, so the theme's close / add-to-cart code works unchanged)
  TabQV.open = function (handle, trigger) {
    var d = drawer(); if (!d || !handle) return;
    var request = ++openId; lastTrigger = trigger || document.activeElement;
    var root = rootUrl();
    var vid = null;
    if (trigger) { trigger.classList.add('loading'); var u; try { u = new URL(trigger.href, location.href); vid = u.searchParams.get('variant'); } catch (e) {} }
    var href = hrefFor(handle, vid);
    var productUrl = root.replace(/\/$/, '') + '/products/' + handle + (vid ? '?variant=' + encodeURIComponent(vid) : '');
    var filled = false;
    var fallback = setTimeout(function () { if (request === openId && !filled && document.body.classList.contains('open-quick-view')) location.href = productUrl; }, FALLBACK_MS);
    d.classList.add('tqv-drawer');
    var content = d.querySelector('#Product-Drawer-Content');
    content.innerHTML = '';
    document.body.classList.add('open-cc'); document.body.classList.add('open-quick-view');
    d.classList.add('active');
    d.setAttribute('role','dialog'); d.setAttribute('aria-modal','true'); d.setAttribute('aria-label','Choose options');
    document.body.classList.add('tqv-open');
    fetchQV(href).then(function (text) {
      if (request !== openId) { clearTimeout(fallback); return; }
      var doc = new DOMParser().parseFromString(text, 'text/html');
      var src = doc.querySelector('#Product-Drawer-Content');
      if (!src) { clearTimeout(fallback); location.href = productUrl; return; }
      filled = true; clearTimeout(fallback);
      content.classList.remove('tqv-waiting');
      content.innerHTML = src.innerHTML;
      waitForStyles(content, 1500);
      content.querySelectorAll('script[src]').forEach(function (s) { loadScript(s.getAttribute('src')); });
      initAll();
      var close = d.querySelector('.side-panel-close'); if (close) { close.setAttribute('tabindex','0'); close.setAttribute('role','button'); close.setAttribute('aria-label','Close quick view'); close.focus(); }
      setTimeout(function () { var c = d.querySelector('.product-quick-images--container'); if (c) c.classList.add('active'); });
      setTimeout(function () { if (window.Shopify && Shopify.PaymentButton) { try { Shopify.PaymentButton.init(); } catch (e) {} } }, 300);
      if (typeof dispatchCustomEvent === 'function') dispatchCustomEvent('quick-view:open', { productUrl: href, productHandle: handle });
    }).catch(function () { clearTimeout(fallback); if (request === openId) location.href = productUrl; })
      .finally(function () { if (trigger) trigger.classList.remove('loading'); });
  };
  TabQV.close = function () {
    ++openId;
    var d = drawer(); if (!d) return;
    var c = d.querySelector('#Product-Drawer-Content'); if (c) c.classList.remove('tqv-waiting');
    d.classList.remove('active');
    document.body.classList.remove('open-quick-view','tqv-open');
    var cart = document.getElementById('Cart-Drawer');
    if (cart && cart.classList.contains('active')) document.body.classList.add('open-cc','open-cart');
    else document.body.classList.remove('open-cc');
    if (lastTrigger && lastTrigger.isConnected) lastTrigger.focus({preventScroll:true});
  };

  // Use one loader from both entry points; capture precedes the theme's old quick-view click handler.
  document.addEventListener('click', function (e) {
    var d = drawer(), a = e.target.closest && e.target.closest('[data-tab-qv], quick-view[data-product-handle]');
    if (a && !e.metaKey && !e.ctrlKey && !e.shiftKey && e.button === 0) {
      e.preventDefault(); e.stopImmediatePropagation();
      TabQV.open(a.getAttribute('data-tab-qv') || a.dataset.productHandle, a); return;
    }
    if (d && d.classList.contains('active') && (e.target === d || e.target.closest('#Product-Drawer .side-panel-close'))) {
      e.preventDefault(); e.stopImmediatePropagation(); TabQV.close();
    }
  }, true);
  document.addEventListener('keydown', function (e) {
    var d = drawer(); if (!d || !d.classList.contains('active') || !document.body.classList.contains('open-quick-view')) return;
    if (e.key === 'Escape') { e.preventDefault(); e.stopImmediatePropagation(); TabQV.close(); return; }
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('.side-panel-close')) { e.preventDefault(); TabQV.close(); return; }
    if (e.key === 'Tab') {
      var list = Array.prototype.filter.call(d.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex="0"]'), function(el){return el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden';});
      var first=list[0], last=list[list.length-1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }, true);
  document.addEventListener('cart:item-added', function () {
    document.body.classList.remove('tqv-open');
  });

  // The theme's own <quick-view> elements (cart drawer) inject the same markup: initialise it whenever the drawer's content changes.
  function watch() {
    var d = drawer(); if (!d) return;
    var content = d.querySelector('#Product-Drawer-Content'); if (!content) return;
    new MutationObserver(function () { if (content.querySelector('.tqv')) { d.classList.add('tqv-drawer'); initAll(); } }).observe(content, { childList: true });
    d.classList.add('tqv-drawer');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { watch(); initAll(); }); else { watch(); initAll(); }
})();
